import { servicesArray } from "data/variables";
import Link from "next/link";
import { includes } from "ramda";
import { useEffect, useMemo, useState } from "react";
import styles from "./servicesOne.module.css";

const SvgTitle = () => (
  <svg width="47" height="48" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="var(--text-color)" />
    <rect y="26.9922" width="20.7839" height="20.7839" rx="2.36181" fill="#6C8EF8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.6132 26.9922C33.9692 26.9922 32.6365 28.3249 32.6365 29.9689V34.4079L28.1984 34.4079C26.5544 34.4079 25.2217 35.7406 25.2217 37.3846C25.2217 39.0286 26.5544 40.3613 28.1984 40.3613H32.6365V44.7994C32.6365 46.4434 33.9692 47.7761 35.6132 47.7761C37.2572 47.7761 38.5899 46.4434 38.5899 44.7994V40.3613H43.0289C44.6729 40.3613 46.0056 39.0286 46.0056 37.3846C46.0056 35.7406 44.6729 34.4079 43.0289 34.4079L38.5899 34.4079V29.9689C38.5899 28.3249 37.2572 26.9922 35.6132 26.9922Z"
      fill="var(--text-color)"
    />
    <rect x="25.2227" y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#6C8EF8" />
  </svg>
);

const clickableOptions = [
  { label: "All Services", key: "all" },
  { label: "Social media", key: "social" },
  { label: "Work & Productivity", key: "work" },
];

const Grid = () => {
  const [flags, setFlags] = useState({});
  useEffect(() => {
    fetch("https://client-metadata.redact.dev/main/flags.json")
      .then((res) => res.json())
      .then((body) => setFlags(body));
  }, []);

  const [searchQuery, setSearchQuery] = useState("");

  const [filterItem, setFilterItem] = useState("all");
  const filteredServicesArray = useMemo(() => {
    return servicesArray.filter((val) => {
      if (filterItem === "all") {
        return includes(searchQuery.toLowerCase(), val.title.toLowerCase());
      }
      return (
        includes(searchQuery.toLowerCase(), val.title.toLowerCase()) &&
        includes(filterItem, val.types)
      );
    });
  }, [filterItem, searchQuery]);

  return (
    <div className={styles.grid__wrapper}>
      <div className={styles.search__wrapper}>
        <div className={styles.search__buttons}>
          {clickableOptions.map((val) => {
            return (
              <button
                className={`${styles.search__button} ${
                  val.key === filterItem ? styles.search__button__active : ""
                }`}
                key={val.key}
                onClick={() => setFilterItem(val.key)}
              >
                {val.label}
              </button>
            );
          })}
        </div>
        <div className={styles.search__input_wrapper}>
          <svg
            className="bi bi-search"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M10.442 10.442a1 1 0 011.415 0l3.85 3.85a1 1 0 01-1.414 1.415l-3.85-3.85a1 1 0 010-1.415z"
              clipRule="evenodd"
            />
            <path
              fillRule="evenodd"
              d="M6.5 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM13 6.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
              clipRule="evenodd"
            />
          </svg>
          <input
            type="search"
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search Services"
            value={searchQuery}
          />
        </div>
      </div>
      <div className={styles.grid}>
        {filteredServicesArray.map((value) => {
          const disabled = flags[`axe.${value.icon}.killswitch`];
          if (disabled) {
            return null;
          }
          if (value.title === "Youtube") {
            return null;
          }
          if (value.title === "Blogger") {
            return null;
          }
          return (
            <div
              className={`${styles.grid_item__wrapper} ${
                disabled ? styles.grid_item__wrapper__disabled : ""
              }`}
              key={value.title}
            >
              <Link
                href={disabled ? "#" : `/services/${value.icon}`}
                passHref
                className={styles.grid_item}
              >
                <div
                  className={styles.grid_item__border}
                  style={{ background: value.color || "var(--text-color)" }}
                />
                <div className={styles.grid_item__content}>
                  <div className={styles.grid_item__title}>
                    <h3>{value.title}</h3>
                  </div>
                  <div className={styles.grid_item__body}>
                    {disabled && <div className={styles.coming_soon}>Temporarily disabled</div>}
                    {value.description}
                    <br />
                    <br />
                    <div>You can delete:</div>
                    <div className={styles.grid_item__italic}>{value.removable}</div>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const SubHero = () => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header__wrapper}>
          <div className={styles.header__svg}>
            <SvgTitle />
          </div>
          <div className={styles.header__container}>
            <h2>Services we support</h2>
            <p>
              We are frequently updating support to other social network services. See below what
              other platforms we are working on.
            </p>
          </div>
        </div>
        <Grid />
      </div>
    </section>
  );
};

export default SubHero;
